import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "h-full flex items-center text-black" }
const _hoisted_2 = { class: "flex items-center justify-center p-2 pl-1.5 pr-0 rounded" }
const _hoisted_3 = { class: "h-14" }
const _hoisted_4 = { class: "flex flex-row" }
const _hoisted_5 = { class: "w-2/3 text-center flex flex-row items-center" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "flex flex-row mx-24 mb-6" }
const _hoisted_8 = { class: "text-6xl font-bold w-full relative text-slate-600 overflow-hidden" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "absolute -left-1 top-[1px] h-[1px] w-[110%] bg-gray-200" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "absolute left-1 bottom-[1px] h-[1px] w-[110%] bg-gray-200" }, null, -1)
const _hoisted_11 = { class: "w-1/3 border-l px-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShipmentIcon = _resolveComponent("ShipmentIcon")!
  const _component_InlineSvg = _resolveComponent("InlineSvg")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_PopoverButton = _resolveComponent("PopoverButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PopoverPanel = _resolveComponent("PopoverPanel")!
  const _component_Popover = _resolveComponent("Popover")!

  return (_openBlock(), _createBlock(_component_Popover, { class: "relative" }, {
    default: _withCtx(({ open }) => [
      _createVNode(_component_PopoverButton, {
        class: _normalizeClass([open ? '' : '', "inline-flex items-center text-base text-gray-500 pl-3 py-2 text-sm font-medium group hover:text-opacity-100 focus:outline-none"])
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_ctx.hasShipment)
                  ? (_openBlock(), _createBlock(_component_ShipmentIcon, {
                      key: 0,
                      totalRounds: _ctx.totalRounds
                    }, null, 8, ["totalRounds"]))
                  : (_openBlock(), _createBlock(_component_InlineSvg, {
                      key: 1,
                      src: require(`@/assets/icons/person.svg`),
                      class: "inline w-10 h-10 mt-2 stroke-[0.5]",
                      height: "10"
                    }, null, 8, ["src"]))
              ]),
              _createVNode(_component_ChevronDownIcon, {
                class: _normalizeClass([open ? 'text-indigo-500' : '', "inline-block w-5 h-5 transition duration-150 ease-in-out"]),
                "aria-hidden": "true"
              }, null, 8, ["class"])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["class"]),
      _createVNode(_Transition, {
        "enter-active-class": "transition duration-200 ease-out",
        "enter-from-class": "translate-y-1 opacity-0",
        "enter-to-class": "translate-y-0 opacity-100",
        "leave-active-class": "transition duration-150 ease-in",
        "leave-from-class": "translate-y-0 opacity-100",
        "leave-to-class": "translate-y-1 opacity-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_PopoverPanel, {
            class: "z-40 origin-top-right top-20 absolute right-0 w-[600px] rounded-md shadow-lg py-1 bg-white border border-slate-300 focus:outline-none",
            role: "menu"
          }, {
            default: _withCtx(({ close }) => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_InlineSvg, {
                        src: require(`@/assets/icons/boxes.svg`),
                        class: "inline mr-1 opacity-80",
                        width: "90"
                      }, null, 8, ["src"]),
                      _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createTextVNode(" " + _toDisplayString(_ctx.totalRounds) + " ", 1),
                        _hoisted_10
                      ])
                    ]),
                    _createTextVNode(" You have " + _toDisplayString(_ctx.totalRounds) + " rounds ready to ship ", 1),
                    _createVNode(_component_router_link, {
                      to: "/account/shipping-cart",
                      onClick: close,
                      class: "block px-4 py-2 font-bold text-sm text-blue-700 hover:text-blue-500",
                      role: "menuitem"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Open Your Shipping Cart")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_router_link, {
                    to: "/account",
                    onClick: close,
                    class: "block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100",
                    role: "menuitem"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Overview")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_router_link, {
                    to: "/account/profile-settings",
                    onClick: close,
                    class: "block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 border-t",
                    role: "menuitem"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Profile Settings")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_router_link, {
                    to: "/account/cash-balance",
                    onClick: close,
                    class: "block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 border-t",
                    role: "menuitem"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Cash Management")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_router_link, {
                    to: "/account/asset-management",
                    onClick: close,
                    class: "block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100",
                    role: "menuitem"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Asset Management")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_router_link, {
                    to: "/account/shipping-history",
                    onClick: close,
                    class: "block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100",
                    role: "menuitem"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Shipping History")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_router_link, {
                    to: "/account/pending-trades",
                    onClick: close,
                    class: "block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 border-t",
                    role: "menuitem"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Pending Trades")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_router_link, {
                    to: "/account/completed-trades",
                    onClick: close,
                    class: "block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100",
                    role: "menuitem"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Completed Trades")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createElementVNode("a", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                    class: "cursor-pointer block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 border-t",
                    role: "menuitem"
                  }, "Logout")
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}